import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { withTheme } from '@material-ui/core/styles';
import WeatherForecast from './fancy/WeatherForecast';
import ReadonlyEditor from './drafteditor/components/ReadonlyEditor';

function GolfCourseDetail({ theme, selectedActivity }) {
    const [detailsOpen, setDetailsOpen] = useState(false);

    if (!selectedActivity) {
        return null;
    }

    return (
        <Grid item container id="golf-activities" className="mb-3">
            <Grid item container alignItems="center" style={{ marginBottom: '0.5rem' }}>
                <h1>{selectedActivity.name}</h1>
                <span
                    style={{ color: theme.palette.primary.main }}
                    className="details-opener"
                    onClick={() => setDetailsOpen(!detailsOpen)}
                >
                    {detailsOpen ? '- Hide Course Details' : '+ Show Course Details'}
                </span>
            </Grid>
            {detailsOpen && (
                <Grid item container className="mb-2 details">
                    <Grid item sm={8} xs={12} className="description">
                        <ReadonlyEditor value={selectedActivity?.description} />
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        {' '}
                        <WeatherForecast />
                    </Grid>
                </Grid>
            )}

            <Grid
                item
                container
                className="golf-cover"
                style={{
                    backgroundImage: `url(${selectedActivity.image})`
                }}
            />
        </Grid>
    );
}

export default withTheme(GolfCourseDetail);
